import React, { useContext } from "react";

// Models
import ICarouselContentDTO from "../../../../../Models/DTOs/ICarouselContentDTO";

// Helpers
import { createPlaceholderICarouselContentDTO } from "../../../../../Helpers/Content/CarouselContent";

// Components
import ButtonPill from "../../../../Buttons/ButtonPill";
import LandscapeContentItem from "../../LandscapeContentItem";

// Context
import { UserAuthenticationContext } from "../../../../../Context/UserAuthenticationContext";

type VideoContentGridLandscapeProps = {
    isDarkMode: boolean;
    heading?: string;
    accentColor?: string;
    carouselItems?: ICarouselContentDTO[];
    buttonText?: string;
    buttonLink?: string;
    customLoadingItemCount?: number;
    isLoading?: boolean;
    backgroundHex?: string;
};

const VideoContentGridLandscape: React.FC<VideoContentGridLandscapeProps> = (
    {
        isDarkMode,
        heading,
        accentColor,
        carouselItems,
        buttonText,
        buttonLink,
        customLoadingItemCount,
        isLoading,
        backgroundHex
    }
) => {
    const
        shouldShowLoadingItems = isLoading || !carouselItems,
        items = shouldShowLoadingItems || carouselItems.length === 0
            ? createPlaceholderICarouselContentDTO(customLoadingItemCount ?? 10)
            : carouselItems,

        authCtx = useContext(UserAuthenticationContext);

    return (
        <section className={`layout--video-content-grid-landscape ${isDarkMode ? "is-dark-mode" : "has-light-mode"}`} style={{ background: backgroundHex ? backgroundHex : 'auto' }}>
            <div className={`video-content-grid-landscape__heading ${accentColor ? "has-accent-color" : "no-accent-color"}`}>
                {heading && (
                    <h1>
                        {accentColor && <span style={{background: accentColor}}/>}
                        {heading}
                    </h1>
                )}

                {buttonText && buttonLink && (
                    <ButtonPill
                        label={buttonText}
                        link={buttonLink}
                    />
                )}
            </div>

            <div className="video-content-grid-landscape__grid">
                {items.map((item, i) => (
                    <LandscapeContentItem
                        key={i}
                        item={item}
                        userData={authCtx.userData}
                        authTokenExists={authCtx.doesAuthTokenExist()}
                        isLoading={shouldShowLoadingItems}
                    />
                ))}
            </div>
        </section>
    );
};

export default VideoContentGridLandscape;
